export default __webpack_public_path__ + "static/media/LinkedIn - Negative.803abde2.svg";